import React, { useEffect, useState } from 'react';
import {
  Card,
  Row,
  Col,
  Form,
  Input,
  DatePicker,
  Checkbox,
  Divider,
  Select,
  notification,
} from 'antd';
import FormInput from 'components/FormInput';
import Text from 'antd/lib/typography/Text';
import moment from 'moment';
import { toCurrency } from 'utils/utils';
import ParListSelect from 'components/ParListSelect';
import { FormInstance } from 'antd/lib/form';
import { dateToString, shouldUpdateCompare } from 'utils/utils2';
import ThirdPartyInput from 'components/ThirdPartyInput';
import {
  findAssetPayScheduleByAnyRef,
  FindAssetPayScheduleByAnyRefParams,
  getNotInvoicedAssetByAnyRef,
} from 'services/assets';
import AccountingEntryModal from 'pages/Accounting/Components/AccountingEntryModal';
import ContractDetailModal from 'pages/Accounting/Components/ContractDetailModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import Value from 'components/Value';
import { DataGridColDef } from 'components/DataGrid/DataGrid';
import DataGrid from 'components/DataGrid';
import Title from 'antd/lib/typography/Title';
import {
  getMgParValueByParCode,
  getMgWithHoldingTaxList,
  gettaxrate,
  MgWithHoldingTax,
} from 'services/parametersService';
import _, { isEmpty, isNil, sumBy } from 'lodash';
import { findSIBeneficiary } from 'services/thirdParty';
import UtinaCard from 'components/UtinaCard';
import ModalControllerNV from 'components/ModalControllerNV';
import SIDetail from '..';
import { useQuery } from 'react-query';
import {
  getSIfilesByCriteria,
  getSIfilesByCriteriaParams,
} from 'services/supplierInvoice';
import FormItem from 'antd/lib/form/FormItem';
import SearchOutlined from '@ant-design/icons/SearchOutlined';
import ContractListSelect from 'components/ContractListSelect';

export type tabSupplierInvoiceProps = {
  form: FormInstance;
  refresh: () => void;
  sitype: string;
};

const { Option } = Select;

const TabSupplierInvoice = ({
  form,
  refresh,
  sitype,
}: tabSupplierInvoiceProps) => {
  const [state, setstate] = useState<any>({
    sidetail: [],
    sitype: '',
    disableSItype: false,
    multipleContract: false,
    sicomplevel: false,
    listAsset: [],
    filtredListAsset: [],
    withtax: false,
    tpidTresor: 0,
  });
  const [selectedAssetsKeys, setselectedAssetsKeys] = useState<Array<number>>(
    []
  );
  const [paramsPaySchedule, setparamsPaySchedule] =
    useState<FindAssetPayScheduleByAnyRefParams>({
      assetreference: '',
      complevel: false,
      ctreference: '',
      currcode: '',
      deliveryreference: '',
      orderreference: '',
      idsupplier: 0,
    });

  const { isFetching: isloadingPaySchedule, refetch: refetchAssetPaySchedule } =
    useQuery(
      ['findAssetPayScheduleByAnyRef', paramsPaySchedule],
      () =>
        findAssetPayScheduleByAnyRef(paramsPaySchedule)
          .then((res) => {
            form.setFieldsValue({ AssetPaySchedule: res.list });
          })
          .catch(() => {
            form.setFieldsValue({
              AssetPaySchedule: [],
            });
          }),
      {
        enabled:
          paramsPaySchedule.currcode !== '' &&
          paramsPaySchedule.idsupplier !== 0 &&
          paramsPaySchedule.idsupplier !== undefined &&
          state.sitype === 'ADVANCE',
        staleTime: 1000 * 60 * 2,
      }
    );

  const [paramsSIfiles, setparamsSIfiles] =
    useState<getSIfilesByCriteriaParams>({
      currcode: '',
      duedate: moment(Date.now()).format('YYYY-MM-DD'),
      servcode: '',
      sfStatus: '',
      tpidsupplier: 0,
      mgid: '' as any,
    });

  const { isFetching: isloadingSIfiles, refetch: refetchSIfiles } = useQuery(
    ['getSIfilesByCriteria', paramsSIfiles],
    () =>
      getSIfilesByCriteria(paramsSIfiles)
        .then((res) => {
          if (state.sitype === 'FINOUT')
            form.setFieldsValue({
              SIfiles: res.list.filter(
                (ele: any) => ele.servcode === '' || isNil(ele.servcode)
              ),
            });
          else
            form.setFieldsValue({
              SIfiles: res.list.filter(
                (ele: any) => ele.servcode !== '' && !isNil(ele.servcode)
              ),
            });
        })
        .catch(() => {
          form.setFieldsValue({
            SIfiles: [],
          });
        }),
    {
      enabled:
        paramsSIfiles.tpidsupplier !== 0 &&
        paramsSIfiles.currcode !== '' &&
        ['FINOUT', 'SERVOUT'].includes(state.sitype),
      staleTime: 1000 * 60 * 2,
    }
  );

  let ord = 0;

  useEffect(() => {
    (async () => {
      await getMgParValueByParCode({ parcode: 'WHTENABLED' }).then((res) => {
        if (res.data.parvaluemin === 'true') state.withtax = true;
      });

      await getMgParValueByParCode({ parcode: 'TRESOR' }).then((res) => {
        setstate({ ...state, tpidTresor: Number(res?.data?.parvaluemin) });
        form.setFieldsValue({ tpidTresor: Number(res?.data?.parvaluemin) });
      });
    })();
    if (form.getFieldValue('sistatus') === 'INIT') {
      getlistholdingtax(form.getFieldValue('sitype') ?? sitype);
    }
  }, [sitype]);

  const getlistholdingtax = async (value: any) => {
    if (!isNil(value))
      await getMgWithHoldingTaxList({ sitype: value }).then((res) => {
        form.setFieldsValue({ listHoldingTax: res.list });
      });
  };

  const fetchAssetByCTreference = async (
    idsupplier: number,
    complevel: boolean
  ) => {
    form.setFieldsValue({ tppid: idsupplier });

    await getNotInvoicedAssetByAnyRef({
      assetreference: '',
      ctreference: '',
      deliveryreference: '',
      idsupplier: idsupplier,
      orderreference: '',
      complevel: complevel,
      currcode: form.getFieldValue('currcode') ?? '',
    }).then((response) => {
      const listAsset = response.list?.map((asset) => ({
        text: `${asset.ctreference} - (${asset.clientname}) - ${asset.assetreference} - ${asset.assetlabel} : ${asset.assetgrossamount} `,
        value: asset.assetid,
        assetid: asset.assetid,
        orderreference: asset.assetorderreference,
        currcode: asset.currcode,
        assetreference: asset.assetreference,
        deliveryreference: asset.assetdeliveryreference,
        silorder: asset.assetorderreference,
        silid: (ord += 1),
        deliverydate: dateToString(asset.assetdeliverydate),
        orderdate: asset.assetorderdate,
        assetmulticomponents: false,
        ctrid: asset.ctrid,
        tpidsupplier: asset.tpidsupplier,
        suppliername: asset.suppliername,
        clientname: asset.clientname,
        tpidclient: asset.tpidclient,
        tpidbeneficiary: asset.tpidsupplier,
        sistype: 'PAYMENT',
        clientreference: asset.clientreference,
        refsupplier: asset.refsupplier,
        siltype: 'ASSET', //asset.assettype,
        sillabel: asset.assetlabel,
        silcategory: complevel === false ? 'ASSET' : 'COMP',
        sildescription: asset.ctreference + ' - ' + asset.assetlabel, //asset.assetdescription,
        silnettotalamount: asset.assetnetamount,
        silgrosstotalamount: asset.assetgrossamount,
        siltaxtotalamount: asset.assettaxamount,
        silnetunitmount: asset.assetoriginalnetamount,
        sildiscountperc: asset.assetdiscountrate,
        silnetunitamountafterd: asset.assetnetamount,
        siltaxcode: asset.taxcode,
        silquantity: 1,
        sisamount: asset.assetgrossamount,
        ctreference: asset.ctreference,
        flagholdback: asset.flagholdback,
        holdbackamount: asset.holdbackamount,
        holdbackpercentage: asset.holdbackpercentage,
        holdbackbeleasenbdays: asset.holdbackbeleasenbdays,
        holdbackbeleasedate: asset.holdbackbeleasedate,
        id: Math.round(_.random(20555555555555) * 10000000),
        compid: asset?.compid,
      }));

      const currentcurrency = form.getFieldValue('currcode');
      const filteredList = !isNil(currentcurrency)
        ? listAsset?.filter((asset) => asset.currcode === currentcurrency)
        : listAsset;

      setstate({
        ...state,
        listAsset: listAsset,
        filtredListAsset: filteredList,
      });
    });
  };
  const searchby = (value: any, tosearch: string) => {
    const list = state.listAsset;
    let filteredList = [];
    switch (tosearch) {
      case 'ctreference':
        filteredList = list.filter((ele: any) =>
          ele.ctreference.includes(String(value))
        );
        break;
      case 'clientname':
        filteredList = list.filter((ele: any) =>
          ele.clientname.includes(String(value))
        );
        break;
      case 'assetlabel':
        filteredList = list.filter((ele: any) =>
          ele.sillabel.includes(String(value))
        );
        break;
    }

    setstate({ ...state, filtredListAsset: filteredList });
  };
  const searchPaySchedule = async (value: any, tosearch: string) => {
    await refetchAssetPaySchedule();
    const list = form.getFieldValue('AssetPaySchedule');
    let filteredList = [];
    switch (tosearch) {
      case 'assetreference':
        filteredList = list.filter((ele: any) =>
          ele.assetreference.includes(String(value))
        );
        break;
      case 'ctreference':
        filteredList = list.filter((ele: any) =>
          ele.ctreference.includes(String(value))
        );
        break;
      case 'deliveryreference':
        filteredList = list.filter((ele: any) =>
          ele.deliveryreference.includes(String(value))
        );
        break;
      case 'orderreference':
        filteredList = list.filter((ele: any) =>
          ele.orderreference.includes(String(value))
        );
        break;
    }
    form.setFieldsValue({ AssetPaySchedule: filteredList });
  };
  const searchSIFIlesby = async (value: any, tosearch: string) => {
    await refetchSIfiles();
    const list = form.getFieldValue('SIfiles');
    let filteredList = [];
    switch (tosearch) {
      case 'duedate':
        filteredList = list.filter((ele: any) =>
          ele.duedate.includes(String(value))
        );
        break;
      case 'servcode':
        filteredList = list.filter((ele: any) =>
          ele.servcode.includes(String(value))
        );
        break;
      case 'sfStatus':
        filteredList = list.filter((ele: any) =>
          ele.sfStatus.includes(String(value))
        );
        break;
    }
    form.setFieldsValue({ SIfiles: filteredList });
  };
  const calculateSchedule = async (selectedRows: any) => {
    let listTax = form.getFieldValue('listHoldingTax') ?? [];
    let sigrosstotal = form.getFieldValue('sigrosstotal');

    let finalTaxList = listTax?.filter(
      (e: MgWithHoldingTax) =>
        sigrosstotal > e.siamountmin &&
        (e.siamountmax !== null ? sigrosstotal < e.siamountmax : true)
    );

    let benef: any;
    let benefTresor: any;
    await findSIBeneficiary({
      tpid:
        Number(selectedRows[0]?.tpidbeneficiary) ??
        Number(form.getFieldValue('supplier')?.tpid),
      role: 'SUPPLIER',
      ctrid: selectedRows[0]?.ctrid,
    }).then((resp) => {
      benef = resp.list?.find(
        (benf: any) => benf.tpid === selectedRows[0]?.tpidbeneficiary
      );
    });

    await findSIBeneficiary({
      tpid: state.tpidTresor,
      role: 'SUPPLIER',
      ctrid: selectedRows[0]?.ctrid,
    }).then((resp) => {
      benefTresor = resp.list?.find(
        (benf: any) => benf.tpid === state.tpidTresor
      );
    });

    let newDate = '' as any;
    let documentDate = form.getFieldValue('sidocdate');
    if (!isNil(benef?.tppaydelayout)) {
      newDate = moment(documentDate).add(
        benef?.tppaydelayout
          .replace('M', '')
          .substr(1, benef?.tppaydelayout.length),
        'days'
      );
    }

    if (benef?.tppaydelayout.indexOf('M') > -1) {
      newDate = moment(documentDate)
        .add(
          benef?.tppaydelayout
            .replace('M', '')
            .substr(1, benef?.tppaydelayout.length),
          'days'
        )
        .endOf('month');
    }
    const schedule = {
      sisamount: 0,
      sistype: 'WITHTAX',
      tpidbeneficiary: state.tpidTresor,
      sisduedate: newDate,
      mgbankaccount: '',
      sisstatus: '',
      sisdueamount: '',
      ctrid: selectedRows[0]?.ctrid,
      sispaymentdelaycode: benefTresor?.tppaydelayout,
      sispaymentmode: benefTresor?.tppaymodeout,
      tpbeneficiarybankaccount: benefTresor?.tpbklist.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      tpbkid: benefTresor?.tpbklist.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      sisid: Math.round(_.random(10000) * 10000000),
    };
    let newscheduletax = finalTaxList.map((element: MgWithHoldingTax) => {
      return {
        ...schedule,
        sisamount:
          element.whtevaluationmode === 'PERC'
            ? (sigrosstotal * element.whtpercentage) / 100
            : element.whtfixedamount,
        sisdueamount:
          element.whtevaluationmode === 'PERC'
            ? (sigrosstotal * element.whtpercentage) / 100
            : element.whtfixedamount,
      };
    });

    let newDatebenefHold = moment();
    if (!isNil(benef?.tppaydelayout))
      newDatebenefHold = moment().add(
        benef?.tppaydelayout
          ?.replace('M', '')
          .substr(1, benef?.tppaydelayout?.length),
        'days'
      );

    if (benef?.tppaydelayout?.indexOf('M') > -1) {
      newDate = moment()
        .add(
          benef?.tppaydelayout
            ?.replace('M', '')
            .substr(1, benef?.tppaydelayout?.length),
          'days'
        )
        .endOf('month');
    }
    const scheduleHold = {
      sisamount: 0,
      sistype: 'HOLDBACK',
      tpidbeneficiary: selectedRows[0]?.tpidbeneficiary,
      maintpidbeneficiary: selectedRows[0]?.tpidbeneficiary,
      sisduedate: newDatebenefHold,
      mgbankaccount: '',
      sisstatus: '',
      sisdueamount: '',
      ctrid: selectedRows[0]?.ctrid,
      sispaymentdelaycode: benef?.tppaydelayout,
      sispaymentmode: benef?.tppaymodeout,
      tpbeneficiarybankaccount: benef?.tpbklist?.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      tpbkid: benef?.tpbklist?.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      sisid: Math.round(_.random(10000) * 10000000),
    };

    let newscheduleHold = selectedRows
      .filter((e: any) => e.flagholdback === true)
      .map((element: any) => {
        if (!isNil(element.psid))
          return {
            ...scheduleHold,
            tpidbeneficiary: selectedRows[0]?.tpidbeneficiary,
            tpbeneficiarybankaccount: benef?.tpbklist.find(
              (bk: any) =>
                bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
            )?.tpbkid,
            sisduedate:
              element.holdbackbeleasedate !== null
                ? moment(element.holdbackbeleasedate)
                : moment(form.getFieldValue('sidocdate')).add(
                    element.holdbackbeleasenbdays,
                    'days'
                  ),
            holdbackbeleasenbdays: element.holdbackbeleasenbdays,
            holdbackbeleasedate: element.holdbackbeleasedate,
            sisamount: element.holdbackamount,
            sisdueamount: element.holdbackamount,
          };
        else
          return {
            ...scheduleHold,
            sisduedate:
              element.holdbackbeleasedate !== null
                ? moment(element.holdbackbeleasedate)
                : moment(form.getFieldValue('sidocdate')).add(
                    element.holdbackbeleasenbdays,
                    'days'
                  ),
            holdbackbeleasenbdays: element.holdbackbeleasenbdays,
            holdbackbeleasedate: element.holdbackbeleasedate,
            sisamount:
              (element.silgrosstotalamount * element.holdbackpercentage) / 100,
            sisdueamount:
              (element.silgrosstotalamount * element.holdbackpercentage) / 100,
          };
      });

    //clean old holdback
    const linesWithoutHold = form
      .getFieldValue('suppInvoiceSchedules')
      .filter((sch: any) => sch.sistype !== 'HOLDBACK');
    form.setFieldsValue({
      suppInvoiceSchedules: [],
    });
    form.setFieldsValue({
      suppInvoiceSchedules: linesWithoutHold,
    });

    let newschedule = newscheduletax.concat(newscheduleHold);

    // let totaltaxamount =
    //   form.getFieldValue('sitype') === 'ADVANCE'
    //     ? 0
    //     : sumBy(newscheduletax, 'sisamount');
    let totaltaxamount = sumBy(newscheduletax, 'sisamount');

    let totalholdback = sumBy(newscheduleHold, 'sisamount');

    const scheduleP = {
      sisamount: sigrosstotal - (totaltaxamount + totalholdback),
      sistype: 'PAYMENT',
      tpidbeneficiary: selectedRows[0]?.tpidbeneficiary,
      maintpidbeneficiary: selectedRows[0]?.tpidbeneficiary,
      sisduedate: newDate,
      mgbankaccount: '',
      sisstatus: '',
      ctrid: selectedRows[0]?.ctrid,
      sisdueamount: sigrosstotal - totaltaxamount - totalholdback,
      sispaymentdelaycode: benef?.tppaydelayout,
      sispaymentmode: benef?.tppaymodeout,
      tpbeneficiarybankaccount: benef?.tpbklist.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      tpbkid: benef?.tpbklist.find(
        (bk: any) =>
          bk.bkstatus === 'VALID' && ['INOUT', 'OUT'].includes(bk.bktype)
      )?.tpbkid,
      sisid: Math.round(_.random(100000) * 10000000),
    };

    const res2 = [scheduleP].concat(newschedule);
    form.setFieldsValue({
      suppInvoiceSchedules: res2.slice(),
      sisamount: sumBy(res2, 'sisamount'),
    });
  };
  const handleSelectAssetsSchedule = async (psid: any, key: any) => {
    const sigrosstotal = form.getFieldValue('sigrosstotal');

    const line = form
      .getFieldValue('AssetPaySchedule')
      .find((ele: any) => ele.psid === psid);
    const lines = form.getFieldValue('suppInvoiceLines');

    const taxrate = await gettaxrate({
      taxcode: line?.taxcode,
      idate: String(moment(Date.now()).format('YYYY-MM-DD hh:mm:ss')),
    }).then((res) => res);
    const newLine = {
      text: `${line.ctreference} - (${line.clientname}) - ${line.assetreference} - ${line.assetlabel} : ${line.payamount} `,
      value: line.assetid,
      assetid: line.assetid,
      orderreference: line.assetorderreference,
      currcode: line.currcode,
      assetreference: line.assetreference,
      deliveryreference: line.assetdeliveryreference,
      silorder: line.assetorderreference,
      silid: (ord += 1),
      deliverydate: dateToString(line.assetdeliverydate),
      orderdate: line.assetorderdate,
      assetmulticomponents: false,
      ctrid: line.ctrid,
      tpidsupplier: line.tpidsupplier,
      tpidclient: line.tpidclient,

      suppliername: line.suppliername,
      clientname: line.clientname,
      tpidbeneficiary: line.tpidsupplier,
      sistype: 'PAYMENT',
      clientreference: line.clientreference,
      refsupplier: line.refsupplier,
      siltype: 'ADVANCE',
      sillabel: line.assetlabel,
      silcategory:
        form.getFieldValue('sicomplevel') === false ? 'ASSET' : 'COMP',
      sildescription: line.ctreference + ' - ' + line.assetlabel, //line.assetdescription,
      silnettotalamount: line.dueamount,
      silgrosstotalamount: (line.dueamount * (100 + taxrate)) / 100,
      siltaxtotalamount: (line.dueamount * taxrate) / 100,
      siltaxcode: line.taxcode,
      silnetunitmount: line.payamount,
      silquantity: 1,
      sisamount: line.payamount, //* (100+taxrate)) / 100,
      ctreference: line.ctreference,
      flagholdback: line.holdbackamount !== 0,
      holdbackamount: (line.holdbackamount * (100 + taxrate)) / 100,
      holdbackpercentage: line.holdbackpercentage,
      holdbackbeleasedate: line.holdbackreleasedate,
      id: Math.round(_.random(10000) * 10000000),
      compid: line?.compid,
      psid: line?.psid,
    };
    lines.push(newLine);
    form.setFieldsValue({
      sigrosstotal: sigrosstotal + (line.payamount * (100 + taxrate)) / 100,
    });
    form.setFieldsValue({ suppInvoiceLines: lines.slice() });

    refresh();
  };

  const handlesidocdateChange = (newdocdate: moment.Moment | null) => {
    const docdate = moment(newdocdate);
    const docdateF = moment(docdate);
    if (docdateF.isValid()) {
      //update holdbacklines
      let oldSchedule = form.getFieldValue('suppInvoiceSchedules') ?? [];
      //init scheduleLines
      form.setFieldsValue({
        suppInvoiceSchedules: [],
      });

      let newHoldbackSch = oldSchedule
        .filter((sch: any) => sch.sistype === 'HOLDBACK')
        .map((hold: any) => {
          let newdoc = docdateF.add(hold.holdbackbeleasenbdays, 'days');
          return {
            ...hold,
            sisduedate:
              hold.holdbackbeleasedate !== null
                ? moment(hold.holdbackbeleasedate)
                : newdoc,
          };
        });
      oldSchedule = oldSchedule.filter(
        (sch: any) => sch.sistype !== 'HOLDBACK'
      );

      let newSchedule = oldSchedule.concat(newHoldbackSch);
      form.setFieldsValue({ suppInvoiceSchedules: newSchedule });
    } else {
      //delete all holdback lines
      let oldSchedule = form.getFieldValue('suppInvoiceSchedules') ?? [];
      let oldLines = form.getFieldValue('suppInvoiceLines') ?? [];
      form.setFieldsValue({
        suppInvoiceLines: [],
        suppInvoiceSchedules: [],
        sigrosstotal: 0,
        sisamount: 0,
        silnettotalamount: 0,
        sitaxtotal: 0,
      });

      let newLines = oldLines.filter((sch: any) => sch.flagholdback !== true);

      const silnettotalamount = sumBy(newLines, 'silnettotalamount');
      const sitaxtotal = sumBy(newLines, 'siltaxtotalamount');
      const sigrosstotal = sumBy(newLines, 'silgrosstotalamount');

      let newSchedule =
        sigrosstotal > 0
          ? oldSchedule
              .filter(
                (sch: any) =>
                  sch.sistype !== 'HOLDBACK' && sch.flagholdback !== true
              )
              .map((sch: any) =>
                sch.sistype === 'PAYMENT'
                  ? {
                      ...sch,
                      sisdueamount: sigrosstotal,
                      sisamount: sigrosstotal,
                    }
                  : sch
              )
          : [];

      //setnewValues
      form.setFieldsValue({
        suppInvoiceLines: newLines,
        suppInvoiceSchedules: newSchedule,
        sigrosstotal: sigrosstotal,
        sisamount: sigrosstotal,
        silnettotalamount: silnettotalamount,
        sitaxtotal: sitaxtotal,
      });

      //set keys of deleted lines
      setselectedAssetsKeys(newLines.map((line: any) => line.id));
    }
  };

  const handleSelectSIFiles = async (sfid: any, key: any) => {
    const sigrosstotal = form.getFieldValue('sigrosstotal');

    const line = form
      .getFieldValue('SIfiles')
      .find((ele: any) => ele.sfid === sfid);
    const lines = form.getFieldValue('suppInvoiceLines');

    // const taxrate = await gettaxrate({
    //   taxcode: line.taxcode,
    //   idate: String(moment(Date.now()).format('YYYY-MM-DD hh:mm:ss')),
    // }).then((res) => res);
    const newLine = {
      text: `${line.mgname} - (${line.servlabel}) `,
      value: line.sfid,
      currcode: line.currcode,
      silid: (ord += 1),
      tpidsupplier: line.tpidsupplier,
      tpidbeneficiary: line.tpidsupplier,
      sistype: 'PAYMENT',
      siltype: state.sitype === '' ? sitype : state.sitype,
      silcategory: line.servcode,
      sildescription: line.servlabel, //line.assetdescription,
      silnettotalamount: line.sftotalnetamount,
      silgrosstotalamount: line.sftotalgrossamount,
      siltaxtotalamount: line.sftotaltaxamount, //(line.sftotalgrossamount * taxrate) / 100,
      siltaxcode: line.taxcode,
      silnetunitmount: line.sftotalnetamount,
      silquantity: line.sftotallines,
      sisamount: line.sftotalnetamount,
      flagholdback: false,
      id: Math.round(_.random(10000) * 10000000),
      compid: line?.compid,
      // siltaxrate: taxrate ?? 0,
      sfid: line?.sfid,
    };
    lines.push(newLine);
    form.setFieldsValue({
      sigrosstotal:
        sigrosstotal + newLine.sisamount + newLine.siltaxtotalamount,
    });
    form.setFieldsValue({ suppInvoiceLines: lines });

    refresh();
  };

  const handleSelectAssets = (assetid: any, compid: any) => {
    const list = state.listAsset;
    const sigrosstotal = form.getFieldValue('sigrosstotal');

    const res = list.filter(
      (rowItem: any) => rowItem.assetid === assetid && rowItem.compid === compid
    );

    const lines = form.getFieldValue('suppInvoiceLines');
    lines.push(res[0]);
    form.setFieldsValue({ sigrosstotal: sigrosstotal + res[0]?.sisamount });
    form.setFieldsValue({ suppInvoiceLines: lines });

    refresh();
  };

  const handleComplevelContracts = (checked: boolean) => {
    const sitype = form.getFieldValue('sitype');
    form.setFieldsValue({ tppid: form.getFieldValue('supplier').tpid });
    if (sitype === 'ASSETF')
      fetchAssetByCTreference(form.getFieldValue('supplier').tpid, checked);
    paramsPaySchedule.complevel = checked;
    if (sitype === 'ADVANCE') refetchAssetPaySchedule();
  };

  let type = '';
  const isCreate = Boolean(form.getFieldValue('isCreate'));

  const columns: DataGridColDef<any>[] = [
    {
      comcode: 'ctreference',
      dataIndex: 'ctreference',
      width: 100,
      fixed: 'left',
    },
    {
      comcode: 'clientname',
      dataIndex: 'clientname',
      width: 180,
    },

    {
      comcode: 'assetlabel',
      dataIndex: 'sillabel',
      //width: 180,
    },
    {
      align: 'right',
      comcode: 'silnettotalamount',
      dataIndex: 'silnettotalamount',
      fixed: 'right',
      render: (val, record) => toCurrency(val, record.currcode),
      width: 120,
    },
  ];
  const columnsAssetPaySchedule: DataGridColDef<any>[] = [
    {
      comcode: 'assetorderreference',
      dataIndex: 'assetorderreference',
      width: '10%',
    },
    {
      comcode: 'assetreference',
      dataIndex: 'assetreference',
      width: '10%',
    },
    {
      comcode: 'assetlabel',
      dataIndex: 'assetlabel',
      width: '15%',
    },
    {
      comcode: 'ctreference',
      dataIndex: 'ctreference',
      width: '10%',
    },
    {
      comcode: 'paytype',
      dataIndex: 'paytype',
      width: '8%',
    },
    {
      comcode: 'paystatus',
      dataIndex: 'paystatus',
      width: '8%',
    },

    {
      align: 'right',
      comcode: 'payamount',
      dataIndex: 'payamount',
      render: (val, record) => toCurrency(val, record.currcode),
      width: '11%',
    },
    {
      align: 'right',
      comcode: 'holdbackamount',
      dataIndex: 'holdbackamount',
      render: (val, record) => toCurrency(val, record.currcode),
      width: '10%',
    },
    {
      align: 'right',
      comcode: 'dueamount',
      dataIndex: 'dueamount',
      render: (val, record) => toCurrency(val, record.currcode),
      width: '11%',
    },
    {
      comcode: 'payduedate',
      dataIndex: 'payduedate',
      width: '10%',
    },
  ];

  const columnsSIfiles: DataGridColDef<any>[] = [
    {
      comcode: 'servcode',
      dataIndex: 'servcode',
      width: '10%',
    },
    {
      comcode: 'servlabel',
      dataIndex: 'servlabel',
      width: '15%',
    },
    {
      comcode: 'cipaystatus',
      dataIndex: 'cipaystatus',
      width: '10%',
    },
    {
      comcode: 'creationdate',
      dataIndex: 'creationdate',
      render: (val, record) => dateToString(moment(val)),
      width: '15%',
    },
    {
      comcode: 'duedate',
      dataIndex: 'duedate',
      render: (val, record) => dateToString(moment(val)),
      width: '15%',
    },
    // {
    //   comcode: 'sfstatus',
    //   dataIndex: 'sfstatus',
    //   width: 100,
    // },
    {
      comcode: 'sftotallines',
      dataIndex: 'sftotallines',
      width: '10%',
    },
    {
      comcode: 'sftotalnetamount',
      dataIndex: 'sftotalnetamount',
      render: (val, record) => toCurrency(val, record.currcode),
      align: 'right',
      width: '15%',
    },
    {
      comcode: 'sftotaltaxamount',
      dataIndex: 'sftotaltaxamount',
      render: (val, record) => toCurrency(val, record.currcode),
      align: 'right',
      width: '15%',
    },

    {
      comcode: 'sftotalgrossamount',
      dataIndex: 'sftotalgrossamount',
      render: (val, record) => toCurrency(val, record.currcode),
      align: 'right',
      width: '15%',
    },
  ];

  const rowSelection = {
    onChange: async (selectedRowKeys: any, selectedRows: any) => {
      if (
        !(
          selectedRows.find((row: any) => row.flagholdback === true) &&
          isNil(form.getFieldValue('sidocdate'))
        )
      ) {
        setselectedAssetsKeys(selectedRowKeys);
        if (!isEmpty(selectedRows)) {
          form.setFieldsValue({ isUpdating: true });
          if (form.getFieldValue('sitype') === 'ADVANCE') {
            //assetSchedule level
            form.setFieldsValue({ suppInvoiceLines: [], sigrosstotal: 0 });
            for (const i in selectedRows) {
              await handleSelectAssetsSchedule(selectedRows[i].psid, i);
            }
            // calculate Schedule :
            calculateSchedule(form.getFieldValue('suppInvoiceLines'));
          } else if (
            form.getFieldValue('sitype') === 'FINOUT' ||
            form.getFieldValue('sitype') === 'SERVOUT'
          ) {
            //SIFiles level
            form.setFieldsValue({ suppInvoiceLines: [], sigrosstotal: 0 });
            for (const i in selectedRows) {
              await handleSelectSIFiles(selectedRows[i].sfid, i);
            }
            // calculate Schedule :
            calculateSchedule(form.getFieldValue('suppInvoiceLines'));
          } else {
            // asset level
            form.setFieldValue('suppInvoiceLines', []);
            form.setFieldValue('sigrosstotal', 0);

            for (const i in selectedRows) {
              handleSelectAssets(
                selectedRows[i].assetid,
                selectedRows[i].compid
              );
            }
            // calculate Schedule :
            calculateSchedule(selectedRows);
          }
          // }
        }
      } else {
        form.scrollToField('sidocdate');
        notification.error({ message: 'sidocdate required' });
      }
      if (selectedRows.length === 0) {
        refresh();
        form.setFieldsValue({
          suppInvoiceLines: [],
          suppInvoiceSchedules: [],
          sigrosstotal: 0,
          sisamount: 0,
          silnettotalamount: 0,
          sidueamount: 0,
          sitaxtotal: 0,
        });
      }
    },
    getCheckboxProps: (record: any) => ({
      disabled: record.paytype === 'HOLDBACK',
    }),
  };

  return (
    <Card type="inner" title={<GetLabel label="General Data" />}>
      <Row gutter={32}>
        <FormInput col md={4} xs={24} name="sireference">
          <Value />
        </FormInput>

        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) => (
            <FormInput
              name="sitype"
              col
              md={4}
              xs={24}
              rules={[{ required: true }]}
            >
              {isCreate ? (
                <ParListSelect
                  disabled={!isCreate}
                  parcode="SITYPE"
                  onSelect={(e) => {
                    form.setFieldsValue({
                      suppInvoiceLines: [],
                      suppInvoiceSchedules: [],
                      sigrosstotal: 0,
                      sisamount: 0,
                      silnettotalamount: 0,
                      sitaxtotal: 0,
                    });
                    state.sitype = e;

                    refresh();
                    if (e === 'ASSETF' || e === 'ASSETP' || e === 'ADVANCE')
                      type = 'Asset';
                    else type = 'Fees';
                    if (state.withtax === true) getlistholdingtax(e);

                    if (e === 'ADVANCE') refetchAssetPaySchedule();

                    if (e === 'FINOUT' || e === 'SERVOUT') refetchSIfiles();

                    form.setFieldsValue({ siltype: type });
                  }}
                  style={{ width: '100%' }}
                />
              ) : (
                <Text>{getFieldValue('sitypelabel')}</Text>
              )}
            </FormInput>
          )}
        </Form.Item>

        <FormInput col md={2} name="flagcn">
          <Checkbox checked={form.getFieldValue('flagcn')} disabled />
        </FormInput>
        <Form.Item
          noStyle
          label="CN?"
          shouldUpdate={shouldUpdateCompare([
            'refinvoicecreditnote',
            'flagcn',
            'siidcreditnote',
          ])}
        >
          {({ getFieldValue }) =>
            !getFieldValue('flagcn') &&
            getFieldValue('siidcreditnote') && (
              <FormInput
                name="refinvoicecreditnote"
                comcode={
                  form.getFieldValue('flagcn')
                    ? 'refinvoicecreditnote'
                    : 'Notflagcn'
                }
                col
                md={3}
              >
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <a
                      onClick={() =>
                        !(
                          getFieldValue('refinvoicecreditnote') === '' ||
                          !getFieldValue('refinvoicecreditnote')
                        )
                          ? setVisible(true)
                          : null
                      }
                    >
                      {getFieldValue('refinvoicecreditnote') === '' ||
                      !getFieldValue('refinvoicecreditnote')
                        ? 'No'
                        : getFieldValue('refinvoicecreditnote')}
                    </a>
                  )}
                  modal={({ setVisible, visible }) => (
                    <SIDetail
                      siid={getFieldValue('siidcreditnote')}
                      onCancel={() => setVisible(false)}
                      showAsModal
                      visible={visible}
                      showButtons={false}
                    />
                  )}
                />
              </FormInput>
            )
          }
        </Form.Item>
        <FormInput col md={3} name="simultiplecontracts" valuePropName="checked">
          <Checkbox disabled />
        </FormInput>
        <Form.Item noStyle shouldUpdate={shouldUpdateCompare('statuslabel')}>
          {({ getFieldValue }) => (
            <FormInput
              name="statuslabel"
              style={{ color: 'green' }}
              col
              xs={24}
              md={8}
            >
              <Text>
                {!getFieldValue('sistatus')
                  ? form.setFieldsValue({
                      sistatus: 'INIT',
                      sistatuslabel: 'Initial',
                    })
                  : ''}
                {!getFieldValue('statuslabel')
                  ? getFieldValue('sistatuslabel')
                  : getFieldValue('statuslabel')}{' '}
                {!isNil(getFieldValue('sistatusdate'))
                  ? moment(getFieldValue('sistatusdate')).format('YYYY-MM-DD')
                  : ''}
              </Text>
            </FormInput>
          )}
        </Form.Item>
      </Row>
      <Row>
        <UtinaCard
          level={5}
          comcode="general_info"
          style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
          lg={14}
        >
          <Row gutter={32}>
            <FormInput
              name="sidocreference"
              col
              xs={8}
              rules={[{ required: true }]}
            />
            <FormInput name="supplier" col xs={10}>
              <ThirdPartyInput
                role="SUPPLIER"
                onChange={(item) => {
                  paramsSIfiles.tpidsupplier = item.tpid;
                  paramsPaySchedule.idsupplier = item.tpid;
                  paramsSIfiles.currcode =
                    !isNil(form.getFieldValue('currcode')) &&
                    paramsSIfiles.currcode === ''
                      ? form.getFieldValue('currcode')
                      : paramsSIfiles.currcode;
                  paramsPaySchedule.currcode =
                    !isNil(form.getFieldValue('currcode')) &&
                    paramsPaySchedule.currcode === ''
                      ? form.getFieldValue('currcode')
                      : paramsPaySchedule.currcode;
                  const sitype = form.getFieldValue('sitype');
                  if (
                    sitype === 'ASSETF' ||
                    sitype === 'FEES' ||
                    sitype === 'COMM'
                  )
                    fetchAssetByCTreference(
                      item.tpid,
                      form.getFieldValue('sicomplevel') ?? false
                    );
                  if (sitype === 'FINOUT' || sitype === 'SERVOUT')
                    refetchSIfiles();
                  if (sitype === 'ADVANCE') refetchAssetPaySchedule();

                  form.setFieldsValue({
                    suppInvoiceLines: [],
                    suppInvoiceSchedules: [],
                    sigrosstotal: 0,
                    sisamount: 0,
                    silnettotalamount: 0,
                    sitaxtotal: 0,
                    sidueamount: 0,
                    ctreference: '',
                  });
                }}
              />
            </FormInput>

            <FormInput col md={6} name="currcode" rules={[{ required: true }]}>
              <ParListSelect
                parcode="CURRENCY"
                onChange={(val) => {
                  paramsPaySchedule.currcode = val;
                  paramsSIfiles.currcode = val;

                  paramsSIfiles.tpidsupplier =
                    !isNil(form.getFieldValue('tpidsupplier')?.tpid) &&
                    paramsSIfiles?.tpidsupplier === 0
                      ? form.getFieldValue('tpidsupplier')?.tpid
                      : paramsSIfiles?.tpidsupplier;
                  paramsPaySchedule.idsupplier =
                    !isNil(form.getFieldValue('tpidsupplier')?.tpid) &&
                    paramsPaySchedule?.idsupplier === 0
                      ? form.getFieldValue('tpidsupplier')?.tpid
                      : paramsPaySchedule?.idsupplier;
                  const sitype = form.getFieldValue('sitype');

                  if (
                    sitype === 'ASSETF' ||
                    sitype === 'COMM' ||
                    sitype === 'FEES' ||
                    sitype === 'EXPENSE'
                  )
                    fetchAssetByCTreference(
                      form.getFieldValue('supplier')?.tpid,
                      form.getFieldValue('sicomplevel') ?? false
                    );
                  if (sitype === 'ADVANCE') refetchAssetPaySchedule();

                  if (sitype === 'FINOUT' || sitype === 'SERVOUT')
                    refetchSIfiles();

                  const filteredList = state.listAsset.filter(
                    (asset: any) => asset.currcode === val
                  );
                  setstate({ ...state, filtredListAsset: filteredList });
                  form.setFieldsValue({
                    suppInvoiceLines: [],
                    suppInvoiceSchedules: [],
                    sigrosstotal: 0,
                    sisamount: 0,
                    silnettotalamount: 0,
                    sidueamount: 0,
                    sitaxtotal: 0,
                    ctreference: '',
                  });
                }}
              />
            </FormInput>
            <FormInput name="sidocdate" col xs={6} rules={[{ required: true }]}>
              <DatePicker
                disabled={!isCreate}
                onChange={(docdate) => {
                  if (form.getFieldValue('sitype') === 'ASSETF') {
                    handlesidocdateChange(docdate);
                  }
                }}
              />
            </FormInput>
            <Form.Item shouldUpdate noStyle>
              {({ getFieldValue }) => (
                <>
                  {(!(
                    getFieldValue('sitype') === 'ASSETF' ||
                    getFieldValue('sitype') === 'ASSETP' ||
                    getFieldValue('sitype') === 'SERVOUT' ||
                    getFieldValue('sitype') === 'FINOUT'
                  ) ||
                    (form.getFieldValue('ctreference') !== '' &&
                      !isNil(form.getFieldValue('ctreference')))) &&
                      !['FEES', 'COMM'].includes(getFieldValue('sitype')) && (
                      <FormInput
                        col
                        xs={
                          isCreate ||
                          (form.getFieldValue('sistatus') === 'INIT' &&
                            (paramsPaySchedule.currcode !== '' ||
                              paramsPaySchedule.idsupplier !== 0))
                            ? 12
                            : 4
                        }
                        name="ctreference"
                        // rules={[
                        //   { required: ['FEES', 'COMM'].includes(state.sitype) },
                        // ]}
                      >
                        {isCreate ||
                        (form.getFieldValue('sistatus') === 'INIT' &&
                          (paramsPaySchedule.currcode !== '' ||
                            paramsPaySchedule.idsupplier !== 0)) ? (
                          <Select
                            showSearch
                            showArrow={false}
                            allowClear
                            onChange={(k) => {
                              form.setFieldsValue({
                                ctreference: k,
                                ctrid: state.listAsset?.find(
                                  (ctr: any) => ctr?.ctreference === k
                                )?.ctrid,
                              });
                            }}
                            style={{ width: '100%' }}
                          >
                            {_.uniqBy(state.listAsset, 'ctrid').map(
                              (d: any) => (
                                <Option key={d.assetid} value={d.ctreference}>
                                  {d.text}
                                </Option>
                              )
                            )}
                          </Select>
                        ) : (
                          <FormItem shouldUpdate>
                            {({ getFieldValue }) => (
                              <ContractDetailModal
                                ctreference={getFieldValue('ctreference')}
                                ctrid={getFieldValue('ctrid')}
                              />
                            )}
                          </FormItem>
                        )}
                      </FormInput>
                    )}
                  {['FEES', 'COMM'].includes(getFieldValue('sitype')) && (
                    <FormInput
                      col
                      xs={
                        isCreate ||
                        (form.getFieldValue('sistatus') === 'INIT' &&
                          (paramsPaySchedule.currcode !== '' ||
                            paramsPaySchedule.idsupplier !== 0))
                          ? 12
                          : 4
                      }
                      name="ctreference"
                      // rules={[
                      //   { required: ['FEES', 'COMM'].includes(state.sitype) },
                      // ]}
                    >
                      {isCreate ||
                      (form.getFieldValue('sistatus') === 'INIT' &&
                        (paramsPaySchedule.currcode !== '' ||
                          paramsPaySchedule.idsupplier !== 0)) ? (
                            getFieldValue('supplier')?.tagroles?.includes('BROKER') ? (
                              <ContractListSelect
                                form={form}
                                tpidbroker={getFieldValue('supplier')?.tpid}
                              />
                            ) : (
                              <ContractListSelect
                                form={form}
                                tpidsupplier={getFieldValue('supplier')?.tpid}
                              />
                            )
                      ) : (
                        <FormItem shouldUpdate>
                          {({ getFieldValue }) => (
                            <ContractDetailModal
                              ctreference={getFieldValue('ctreference')}
                              ctrid={getFieldValue('ctrid')}
                            />
                          )}
                        </FormItem>
                      )}
                    </FormInput>
                  )}

                  {(!isCreate ||
                    getFieldValue('sitype') === 'ASSETF' ||
                    getFieldValue('sitype') === 'ASSETP' ||
                    getFieldValue('sitype') === 'SERVOUT' ||
                    getFieldValue('sitype') === 'FINOUT') && (
                    <>
                      <Col span={5}>
                        <Form.Item shouldUpdate label="accountingreference">
                          {({ getFieldValue }) => (
                            <Text>
                              <AccountingEntryModal
                                accountingReference={getFieldValue(
                                  'accountingreference'
                                )}
                              />
                            </Text>
                          )}
                        </Form.Item>
                      </Col>
                      <FormInput name="accountingdate" col md={5}>
                        <Value />
                      </FormInput>
                    </>
                  )}
                </>
              )}
            </Form.Item>
          </Row>
          {isCreate &&
            !(
              form.getFieldValue('sitype') === 'ASSETF' ||
              form.getFieldValue('sitype') === 'ASSETP' ||
              form.getFieldValue('sitype') === 'SERVOUT' ||
              form.getFieldValue('sitype') === 'FINOUT'
            ) && (
              <Row>
                <Col span={5}>
                  <Form.Item shouldUpdate label="accountingreference">
                    {({ getFieldValue }) => (
                      <Text>
                        <AccountingEntryModal
                          accountingReference={getFieldValue(
                            'accountingreference'
                          )}
                        />
                      </Text>
                    )}
                  </Form.Item>
                </Col>

                <FormInput name="accountingdate" col md={5}>
                  <Value />
                </FormInput>
              </Row>
            )}
        </UtinaCard>
        <UtinaCard
          level={5}
          comcode="financial_info"
          style={{ color: '#000', marginLeft: 20, paddingTop: 20 }}
          lg={8}
        >
          <Row>
            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare(['currcode', 'sigrosstotal'])}
            >
              {({ getFieldValue }) => {
                return (
                  <FormInput
                    name="sigrosstotal"
                    style={{ color: 'blue' }}
                    col
                    xs={24}
                    md={12}
                  >
                    <Text strong>
                      {toCurrency(
                        getFieldValue('sigrosstotal'),
                        getFieldValue('currcode')
                      )}
                    </Text>
                  </FormInput>
                );
              }}
            </Form.Item>

            <Form.Item
              noStyle
              shouldUpdate={shouldUpdateCompare(['currcode', 'sidueamount'])}
            >
              {({ getFieldValue }) => (
                <FormInput name="sidueamount" col md={12} xs={24}>
                  <Text strong type="danger">
                    {toCurrency(
                      getFieldValue('sidueamount'),
                      getFieldValue('currcode')
                    )}
                  </Text>
                </FormInput>
              )}
            </Form.Item>
          </Row>
        </UtinaCard>
      </Row>
      <br />
      <Row>
        {(isNil(form.getFieldValue('sireference')) ||
          (form.getFieldValue('sistatus') === 'INIT' &&
            (paramsPaySchedule.currcode !== '' ||
              paramsPaySchedule.idsupplier !== 0))) &&
          (form.getFieldValue('sitype') === 'ASSETF' ||
            form.getFieldValue('sitype') === 'ASSETP') && (
            <Col span={24}>
              <Divider>
                <Title level={4} style={{ fontWeight: 'normal' }}>
                  <GetLabel label="Assets" />
                </Title>
              </Divider>

              <Row gutter={16}>
                <Col span={3}>
                  <Title level={5} style={{ fontWeight: 'bold' }}>
                    <GetLabel label="SearchBy" />
                  </Title>
                </Col>
                <FormInput
                  name="sicomplevel"
                  valuePropName="checked"
                  col
                  md={4}
                >
                  <Checkbox
                    onChange={(e) => {
                      handleComplevelContracts(e.target.checked);
                    }}
                  />
                </FormInput>

                {state.multipleContract === false && (
                  <>
                    <FormInput onlylabel="ctreference" col md={6}>
                      {isCreate ? (
                        <Input
                          onChange={(value) => {
                            searchby(value.target.value, 'ctreference');
                          }}
                        />
                      ) : (
                        <FormItem shouldUpdate>
                          {({ getFieldValue }) => (
                            <ContractDetailModal
                              ctreference={getFieldValue('ctreference')}
                              ctrid={getFieldValue('ctrid')}
                            />
                          )}
                        </FormItem>
                      )}
                    </FormInput>
                    <Col span={6}>
                      <FormInput onlylabel="clientname">
                        <Input
                          onChange={(value) => {
                            searchby(value.target.value, 'clientname');
                          }}
                        />
                      </FormInput>
                    </Col>
                    <Col span={4}>
                      <FormInput onlylabel="assetlabel">
                        <Input
                          onChange={(value) => {
                            searchby(value.target.value, 'assetlabel');
                          }}
                        />
                      </FormInput>
                    </Col>
                  </>
                )}
              </Row>
            </Col>
          )}
        {((isNil(form.getFieldValue('sireference')) &&
          (form.getFieldValue('sitype') === 'ASSETF' ||
            form.getFieldValue('sitype') === 'ASSETP')) ||
          (form.getFieldValue('sistatus') === 'INIT' &&
            (paramsPaySchedule.currcode !== '' ||
              paramsPaySchedule.idsupplier !== 0) &&
            (form.getFieldValue('sitype') === 'ASSETF' ||
              form.getFieldValue('sitype') === 'ASSETP'))) && (
          <Row gutter={16}>
            <DataGrid
              size="small"
              scroll={{ x: 1000, y: 400 }}
              pagination={{ pageSize: 10 }}
              rowSelection={{
                type: 'checkbox',
                ...rowSelection,
                selectedRowKeys: selectedAssetsKeys,
              }}
              expandable={{
                expandedRowRender: (record) => (
                  <p style={{ margin: 0, paddingLeft: 20, opacity: '80%' }}>
                    <GetLabel label="Description" />: &nbsp;{' '}
                    {record.sildescription}
                  </p>
                ),
              }}
              columns={columns}
              dataSource={state.filtredListAsset}
              rowKey={(record) => record.id}
            />
          </Row>
        )}
      </Row>
      <FormItem
        shouldUpdate={shouldUpdateCompare(['SIfiles', 'sitype'])}
        noStyle
      >
        {({ getFieldValue }) => (
          <Row>
            {(getFieldValue('sitype') === 'FINOUT' ||
              getFieldValue('sitype') === 'SERVOUT') &&
              (isCreate ||
                (form.getFieldValue('sistatus') === 'INIT' &&
                  (paramsPaySchedule.currcode !== '' ||
                    paramsPaySchedule.idsupplier !== 0))) && (
                <>
                  <Col span={24}>
                    <Divider>
                      <Title level={4} style={{ fontWeight: 'normal' }}>
                        <GetLabel label="Services" />
                      </Title>
                    </Divider>

                    <Row gutter={16}>
                      <Col span={3}>
                        <Title level={5} style={{ fontWeight: 'bold' }}>
                          <GetLabel label="SearchBy" />
                        </Title>
                      </Col>

                      {state.multipleContract === false && (
                        <>
                          <FormInput onlylabel="duedate" col md={6}>
                            <DatePicker
                              onChange={(value) => {
                                searchSIFIlesby(
                                  dateToString(value ?? ''),
                                  'duedate'
                                );
                              }}
                              allowClear
                            />
                          </FormInput>
                          {getFieldValue('sitype') === 'SERVOUT' && (
                            <Col span={6}>
                              <FormInput onlylabel="servcode">
                                <Input
                                  onChange={(value) => {
                                    searchSIFIlesby(
                                      value.target.value,
                                      'servcode'
                                    );
                                  }}
                                  allowClear
                                  prefix={<SearchOutlined />}
                                />
                              </FormInput>
                            </Col>
                          )}
                          {/* <Col span={4}>
                            <FormInput name="sfStatus">
                              <Input
                                onChange={(value) => {
                                  searchSIFIlesby(
                                    value.target.value,
                                    'sfStatus'
                                  );
                                }}
                                allowClear
                                prefix={<SearchOutlined />}
                              />
                            </FormInput>
                          </Col> */}
                        </>
                      )}
                    </Row>
                  </Col>

                  <Row gutter={16}>
                    <DataGrid
                      size="small"
                      scroll={{ x: 1000, y: 400 }}
                      pagination={{ pageSize: 10 }}
                      rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                      }}
                      isLoading={isloadingSIfiles}
                      columns={
                        getFieldValue('sitype') === 'SERVOUT'
                          ? columnsSIfiles
                          : columnsSIfiles.filter(
                              (col) =>
                                col.dataIndex !== 'servlabel' &&
                                col.dataIndex !== 'servcode'
                            )
                      }
                      dataSource={getFieldValue('SIfiles')}
                      rowKey={(record) => record.sfid}
                    />
                  </Row>
                </>
              )}
          </Row>
        )}
      </FormItem>
      <FormItem
        shouldUpdate={shouldUpdateCompare(['AssetPaySchedule', 'sitype'])}
        noStyle
      >
        {({ getFieldValue }) => (
          <Row>
            {getFieldValue('sitype') === 'ADVANCE' &&
              (isCreate ||
                (form.getFieldValue('sistatus') === 'INIT' &&
                  (paramsPaySchedule.currcode !== '' ||
                    paramsPaySchedule.idsupplier !== 0))) && (
                <>
                  <Col span={24}>
                    <Divider>
                      <Title level={4} style={{ fontWeight: 'normal' }}>
                        <GetLabel label="Schedules" />
                      </Title>
                    </Divider>

                    <Row gutter={16}>
                      <Col span={3}>
                        <Title level={5} style={{ fontWeight: 'bold' }}>
                          <GetLabel label="SearchBy" />
                        </Title>
                      </Col>
                      <FormInput
                        name="sicomplevel"
                        valuePropName="checked"
                        col
                        md={4}
                      >
                        <Checkbox
                          onChange={(e) => {
                            handleComplevelContracts(e.target.checked);
                          }}
                        />
                      </FormInput>

                      {state.multipleContract === false && (
                        <>
                          <FormInput onlylabel="assetreference" col md={4}>
                            <Input
                              onChange={(value) => {
                                searchPaySchedule(
                                  value.target.value,
                                  'assetreference'
                                );
                              }}
                              allowClear
                              prefix={<SearchOutlined />}
                            />
                          </FormInput>
                          <Col span={4}>
                            <FormInput onlylabel="ctreference">
                              <Input
                                onChange={(value) => {
                                  searchPaySchedule(
                                    value.target.value,
                                    'ctreference'
                                  );
                                }}
                                allowClear
                                prefix={<SearchOutlined />}
                              />
                            </FormInput>
                          </Col>
                          {/* <Col span={4}>
                          <FormInput name="deliveryreference">
                            <Input
                              onChange={(value) => {
                                searchPaySchedule(
                                  value.target.value,
                                  'deliveryreference'
                                );
                              }}
                              allowClear
                              prefix={<SearchOutlined />}
                            />
                          </FormInput>
                        </Col> */}
                          <Col span={4}>
                            <FormInput onlylabel="orderreference">
                              <Input
                                onChange={(value) => {
                                  searchPaySchedule(
                                    value.target.value,
                                    'orderreference'
                                  );
                                }}
                                allowClear
                                prefix={<SearchOutlined />}
                              />
                            </FormInput>
                          </Col>
                        </>
                      )}
                    </Row>
                  </Col>

                  <Row gutter={16}>
                    <DataGrid
                      size="small"
                      scroll={{ x: 1000, y: 400 }}
                      pagination={{ pageSize: 10 }}
                      rowSelection={{
                        type: 'checkbox',
                        ...rowSelection,
                      }}
                      columns={columnsAssetPaySchedule}
                      isLoading={isloadingPaySchedule}
                      dataSource={getFieldValue('AssetPaySchedule')}
                      rowKey={(record) => record.psid}
                    />
                  </Row>
                </>
              )}
          </Row>
        )}
      </FormItem>
    </Card>
  );
};
export default TabSupplierInvoice;
